import { Map, List, fromJS } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import { addItemToArray, deleteItemFromArray, returnStateIfNoAction } from '../helpers';
import { reorderListItems } from '../../functions/lists';


const INIT_STATE = Map({
    items: Map({})
})

const getKeyArray = (campaignId, listId) => {
    const stringId = String(campaignId)
    const stringList = String(listId)

    return ['items', stringId, 'items', stringList]
}

const updateCurrentWeek = (state, action) => {
    const {campaignId, currentWeek } = action.payload
    const stringId = String(campaignId)

    return state.setIn(['items', stringId, 'currentWeek'], currentWeek)
}

const addItem = (state, action) => {
    const {campaignId, listId, itemId } = action.payload
    const keyArray = getKeyArray(campaignId, listId)

    if(state.hasIn(keyArray)) {
        if(-1 === state.getIn(keyArray).findIndex(i => i === itemId)) {
            return addItemToArray(state, keyArray, itemId)
        } else {
            return state
        }
    } else {
        return state.setIn(keyArray, List([itemId]))
    }
}

const reorderItem = (state, action) => {
    const {campaignId, listId, oldIndex, newIndex } = action.payload
    const keyArray = getKeyArray(campaignId, listId)
   

    if(!state.hasIn(keyArray)) {
        return state
    }

    const list = state.getIn(keyArray)
    const reorderList = reorderListItems(list, oldIndex, newIndex)

    return state.setIn(keyArray, reorderList)
}

const deleteItem = (state, action) => {
    const {campaignId, listId, itemId } = action.payload
    const keyArray = getKeyArray(campaignId, listId)

    if(state.hasIn(keyArray) && -1 !== state.getIn(keyArray).findIndex(i => i === itemId)) {
        return deleteItemFromArray(state, keyArray, itemId)
    } else {
        return state
    }
}

const deleteItemCompletely = (state, action) => {
    const itemToDelete = action.payload.itemId
    let immutableState = state

    state.get('items').map((value, key) => {
        value.get('items').map((v, k) => {
            immutableState = deleteItemFromArray(immutableState, ['items', key, 'items', k], itemToDelete)
        })
    })

    return immutableState
}

const onFilter = (state, action) => {
    return state.set('items', fromJS(action.payload.items))
}

const newslettersReducer = (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.NEWSLETTER_FILTER_SUCCESS:
            return onFilter(state, action)
        case actionTypes.NEWSLETTER_DELETE_ITEM:
            return deleteItemCompletely(state, action)
        case actionTypes.NEWSLETTER_UPDATE_NEWSLETTER_CURRENT_WEEK:
            return updateCurrentWeek(state, action)
        case actionTypes.NEWSLETTER_ADD_NEWSLETTER_ITEM:
            return addItem(state, action)
        case actionTypes.NEWSLETTER_REORDER_NEWSLETTER_ITEM:
            return reorderItem(state, action)
        case actionTypes.NEWSLETTER_DELETE_NEWSLETTER_ITEM:
            return deleteItem(state, action)
        default:
            return state
    }
}

export default newslettersReducer